<template>
  <a-box>
    <l-rows gap="3">
      <l-rows
        v-if="confirmationNeeded"
        :gap="0"
      >
        <a-subtitle
          size="5"
          :text="this.$t('common.deleteConfirmation')"
        />
        <a-subtitle
          size="5"
          class="has-text-danger"
          :text="entityName"
        />
      </l-rows>
      <m-input
        v-if="confirmationNeeded"
        v-model="deleteConfirmation"
      />
      <a-button
        variant="danger"
        type="button"
        :disabled="!deleteButtonEnabled"
        :text="buttonLabel"
        @click="handleClick"
      />
    </l-rows>
  </a-box>
</template>

<script>
  import { MInput, AButton, ABox, LRows, ASubtitle } from 'codefabrik-gui-vue'

  export default {
    name: 'DeleteForm',
    components: { MInput, AButton, ABox, LRows, ASubtitle },
    data () {
      return {
        deleteConfirmation: '',
      }
    },
    props: {
      buttonLabel: {
        type: String,
        default: ''
      },
      entityName: {
        type: String,
        default: ''
      },
      confirmationNeeded: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      deleteButtonEnabled () {
        return !this.confirmationNeeded || this.deleteConfirmation === this.entityName
      }
    },
    methods: {
      handleClick () {
        this.$emit('delete')
      },
    },
  }
</script>
